import React, { PropTypes } from 'react';
import { Link } from 'react-router';

const TipDetailHeader = ({ tip, page, save }) => (
  <div className="ui top attached menu">
    <div className="item">
      <a href={`/tips?page=${page}`} className="ui icon back button">
        <i className="sidebar icon" /> Retour à la Liste
      </a>
    </div>
    <div className="header borderless item">
      {tip.title}
      {tip.obsolete && <div className="ui red horizontal label">Supprimé</div>}
    </div>
    <div className="right menu">
      <div className="item">
        <Link
          to="/chapters/new"
          className="ui right floated right labeled icon button"
        >
          <i className="add icon" />
          Ajouter un chapitre
        </Link>
      </div>
      <div className="item">
        <button className="ui right floated primary button" onClick={save}>
          Mettre à jour
        </button>
      </div>
    </div>
  </div>
);

TipDetailHeader.propTypes = {
  tip: PropTypes.object.isRequired,
  page: PropTypes.string.isRequired,
  save: PropTypes.func.isRequired,
};

export default TipDetailHeader;



// WEBPACK FOOTER //
// ./src/modules/tip/components/TipDetailHeader.js